import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex align-items-center gap-0" }
const _hoisted_2 = {
  key: 0,
  class: "hidden md:flex align-items-center mr-1"
}
const _hoisted_3 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_4 = { class: "white-space-nowrap overflow-hidden text-overflow-ellipsis" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex align-items-center" }
const _hoisted_7 = { class: "relative" }

import RoleChangeOverlay from "@/components/RoleChangeOverlay.vue";
import { useLogout } from "@/composables/useLogout";
import { useRoleSwitching } from "@/composables/useRoleSwitching";
import { useAuthStore } from "@/stores/AuthStore";
import { useCursoStore } from "@/stores/CursoStore";
import { useThemeStore } from "@/stores/ThemeStore";
import Button from "primevue/button";
import Menu from "primevue/menu";
import type { MenuItem } from "primevue/menuitem";
import Select from "primevue/select";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBarDashboardChip',
  setup(__props) {

const router = useRouter();
const themeStore = useThemeStore();
const authStore = useAuthStore();
const cursoStore = useCursoStore();
const userMenu = ref();
const { sair } = useLogout();
const {
  buildRoleMenuItems,
  isChangingRole,
  newRoleIcon,
  oldRoleIcon,
  roleChangeMessage,
} = useRoleSwitching();

const shouldShowCursoSelector = computed(() => {
  return authStore.isAuthenticated &&
    !authStore.isAdmin &&
    cursoStore.isReady;
});

const userMenuItems = computed(() => {
  const items: MenuItem[] = [
    {
      label: authStore.user?.name || "",
      class: "font-bold",
      disabled: true,
    },
    { separator: true },
  ];

  if (authStore.hasMultipleRoles) {
    items.push(
      {
        label: "Perfil atual: " + authStore.activeRoleLabel,
        icon: "pi pi-user",
        class: "font-semibold text-color",
        disabled: true,
      },
      ...buildRoleMenuItems({
        activeClass: "font-semibold surface-100 border-left-3 border-primary",
        inactiveLabelPrefix: "Mudar para ",
        showActiveRole: false,
        onBeforeSwitch: () => userMenu.value?.hide?.(),
      }),
      { separator: true },
    );
  }

  items.push(
    {
      label: "Minha Conta",
      icon: "pi pi-cog",
      command: () => {
        router.push({ name: "conta" });
      },
    },
    {
      label: "Central de Atendimento",
      icon: "pi pi-phone",
      command: () => {
        window.open("https://atendimento-dted.ufma.br/", "_blank");
      },
    },
    { separator: true },
    {
      label: "Sair",
      icon: "pi pi-sign-out",
      command: async () => {
        await sair();
      },
    },
  );

  return items;
});

function toggleUserMenu(event: Event) {
  userMenu.value?.toggle(event);
}

const themeToggleIcon = computed(() => themeStore.isDark ? "pi pi-sun" : "pi pi-moon");
const themeToggleLabel = computed(() => themeStore.isDark ? "Alternar para tema claro" : "Alternar para tema escuro");

const toggleTheme = () => {
  themeStore.toggleTheme();
};

const onCursoChange = () => {
  if (cursoStore.cursoAtual) {
    cursoStore.setCursoAtual(cursoStore.cursoAtual);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (shouldShowCursoSelector.value && _unref(cursoStore).hasMultiplosCursos)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Select), {
            modelValue: _unref(cursoStore).cursoAtual,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(cursoStore).cursoAtual) = $event)),
            options: _unref(cursoStore).cursosDisponiveis,
            optionLabel: "nome",
            placeholder: "Selecione um curso",
            onChange: onCursoChange,
            class: "w-15rem md:w-20rem"
          }, {
            value: _withCtx((slotProps) => [
              (slotProps.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "pi pi-graduation-cap text-primary mr-2" }, null, -1)),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(slotProps.value.nome), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(slotProps.placeholder), 1))
            ]),
            option: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "pi pi-graduation-cap text-primary mr-2" }, null, -1)),
                _createElementVNode("div", null, _toDisplayString(slotProps.option.nome), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Button), {
      icon: themeToggleIcon.value,
      text: "",
      rounded: "",
      onClick: toggleTheme,
      class: "border-none text-secondary ml-1 mr-2",
      "aria-label": themeToggleLabel.value
    }, null, 8, ["icon", "aria-label"]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(Button), {
        icon: "pi pi-bars",
        text: "",
        onClick: toggleUserMenu,
        class: "text-secondary border-none",
        "aria-label": "Abrir menu do usuário"
      }),
      _createVNode(_unref(Menu), {
        ref_key: "userMenu",
        ref: userMenu,
        model: userMenuItems.value,
        popup: "",
        class: "mt-1 w-18rem"
      }, null, 8, ["model"])
    ], 512), [
      [_vShow, _unref(authStore).isAuthenticated]
    ]),
    _createVNode(RoleChangeOverlay, {
      visible: _unref(isChangingRole),
      "old-role-icon": _unref(oldRoleIcon),
      "new-role-icon": _unref(newRoleIcon),
      message: _unref(roleChangeMessage)
    }, null, 8, ["visible", "old-role-icon", "new-role-icon", "message"])
  ]))
}
}

})